import React from 'react';
import { motion } from 'framer-motion';

const Team = () => {
  return (
    <section className="py-20 bg-rich-black overflow-hidden" id="team">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {/* Image Side */}
          <motion.div 
            className="w-full lg:w-1/2 relative"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
              <div className="absolute inset-0 bg-gradient-to-tr from-vibrant-red/20 to-transparent z-10 pointer-events-none"></div>
              <img 
                src="https://public.youware.com/image/ce847c80-7723-435d-af1f-3cb6cf281072/szs65l9ur5.jpg" 
                alt="CampusQube Team" 
                className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-dark-charcoal border border-white/10 rounded-lg -z-10 hidden lg:block"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-vibrant-red/10 rounded-full blur-xl -z-10"></div>
          </motion.div>

          {/* Text Side */}
          <motion.div 
            className="w-full lg:w-1/2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          >
            <div className="relative">
              <div className="w-12 h-1 bg-vibrant-red mb-6"></div>
              <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6">
                The People Behind <span className="text-transparent bg-clip-text bg-gradient-to-r from-vibrant-red to-crimson">CampusQube</span>
              </h2>
              <p className="text-lg text-light-gray mb-6 leading-relaxed">
                We're a passionate group of university students dedicated to helping peers discover opportunities and build successful careers. Our mission is to connect, guide, and empower the next generation of leaders.
              </p>
              <p className="text-medium-gray leading-relaxed">
                Driven by innovation and community, we believe in the power of shared knowledge and mentorship to unlock every student's potential.
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Team;
